import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const EditCircularLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'EditCircular' */ './components/EditCircular')
);

export default (store) => {
	return {
		path: 'home/circular-dashboard/:view/edit-circular/:id',
		element: (
			<AsyncLoading
				component={
					<EditCircularLazy
						permission="CanCreateAnnouncements"
						featureFlag="Module:Announcement"
					/>
				}
			/>
		),
	};
};
